// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"97f36188","703":"51ef5e6a"}[chunkId] + ".chunk.js";
};